import React from 'react';
import Navigation from '../components/Navigation';
import Title from '../components/Title';
import PainPoints from '../components/PainPoints';
import Benefits from '../components/Benefits';
import Testimonials from '../components/Testimonials';
import Founder from '../components/Founder';
import JoinForm from '../components/JoinForm';
import RedditPosts from '../components/RedditPosts';

function LandingPage() {
  return (
    <div>
      <Navigation />
      <Title />
      <PainPoints />
      <Benefits />
      <RedditPosts />
      <Testimonials />
      <Founder />
      <JoinForm />
    </div>
  );
}

export default LandingPage; 